import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { StackFilter } from './types';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

const getStackFilters: QueryFunction<
  StackFilter[],
  ['/stack-filters']
> = async () => {
  if (isMockServices()) return await mock(_mockStackFilters);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{
    filters: StackFilter[];
  }>('/search-filters?type=stack', {
    method: 'GET',
  });
  if (response.data) return response.data.filters;
  throw new Error('Failed to fetch stack filters');
};

export default getStackFilters;

export const _mockStackFilters: StackFilter[] = [
  { id: '1', name: 'Marksman - Inquiry', isOrganization: true },
  { id: '2', name: 'Accounting - Accounting', isOrganization: true },
  { id: '3', name: 'Administrator - Default View', isOrganization: true },
  { id: '4', name: 'Closer - Closer', isOrganization: true },
  { id: '5', name: 'Loan Officer - LO', isOrganization: false },
  { id: '6', name: 'Loan Processor - LP', isOrganization: false },
];
